/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Editor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Advanced from './Advanced/index'
import No from './No/index'
import React from 'react'
import Simplified from './Simplified/index'



/** @type {import('Simple/types.js').View} */
export default function Editor({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/Editor"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventActionDataEmailTemplateAdvancedEditorValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'data.email_template.advanced_editor',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventActionDataEmailTemplateAdvancedEditorValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Simplified'}>
<Simplified
  viewPath={`${viewPath}/Simplified`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Advanced'}>
<Advanced
  viewPath={`${viewPath}/Advanced`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}